/**
 * Various checks for empty values. 0/Zero is allowed.
 */
export function isEmptyValue(value) {
    // As 0/Zero is not considered empty value, we need to check for NaN as well. (See below)
    if (Number.isNaN(value)) {
        return true;
    }
    /**
     * 0/Zero is an allowed value, we should not mark this as empty value when type is 'number'.
     * This is often used for properties like 'index' or price values.
     */
    if (typeof value === 'number') {
        return false;
    }
    if (Array.isArray(value) &&
        value.filter((record) => (typeof record === 'number' && !Number.isNaN(record)) || !!record)
            .length === 0) {
        return true;
    }
    if (typeof value === 'object' &&
        value !== null &&
        (Object.keys(value).length === 0 ||
            Object.values(value).filter((record) => (typeof record === 'number' && !Number.isNaN(record)) || !!record).length === 0)) {
        return true;
    }
    return !value;
}
